<template>
  <div id="page-format-absentismo" class="page-format-absentismo">
    <div class="layout-content container-fluid">
      <div class="row">
          <div class="col-12 pt-0" align="right">
            <a :href="serverPath+'/absenteeismPDF/'+this.id+'/'+this.sharp_id" target="_blank">
              <b-button class="btn btn-darkblue-1">
                Descargar PDF
              </b-button>
            </a>
          </div>
        </div>
      <div class="page-content-absentismo mt-0 mt-md-0">
        <!--div class="cont-approval-text d-flex flex-column justify-content-around mt-0 mt-md-0"-->
        <table cellspacing="0" border="0">
          <tr>
            <td style="border-top: 2px solid #000000; border-bottom: 1px solid #000000; border-left: 2px solid #000000; border-right: 1px solid #000000" colspan=2 height="10" align="center" valign=middle bgcolor="#FFFFFF">
              <font color="#000000">C&oacute;digo:</font>
            </td>
            <td style="border-top: 2px solid #000000; border-bottom: 2px solid #000000; border-right: 2px solid #000000" colspan=8 rowspan=3 align="center" valign=middle bgcolor="#FFFFFF"><b>
              <font size=2 color="#C00000">FORMATO UNICO PARA REPORTE DE ABSENTISMOS</font></b>
            </td>
            <td style="border-top: 2px solid #000000; border-bottom: 2px solid #000000; border-left: 2px solid #000000; border-right: 2px solid #000000" colspan=3 rowspan=3 align="center" valign=bottom bgcolor="#FFFFFF">
              <font color="#000000"><br><img src="@/assets/images/absentismos/logoAbsentismos.png" width=200 height=60 hspace=26 vspace=2>
            </font></td>
            </tr>
          <tr>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 2px solid #000000; border-right: 1px solid #000000" colspan=2 height="10" align="center" valign=middle bgcolor="#FFFFFF"><font color="#000000">Pagina 1 de 1</font></td>
            </tr>
          <tr>
            <td style="border-top: 1px solid #000000; border-bottom: 2px solid #000000; border-left: 2px solid #000000; border-right: 1px solid #000000" colspan=2 height="10" align="center" valign=middle bgcolor="#FFFFFF"><font color="#000000">Actualizaci&oacute;n:</font></td>
            </tr>        
          <tr>
            <td style="border-top: 2px solid #000000; border-bottom: 2px solid #000000; border-left: 2px solid #000000; border-right: 2px solid #000000" colspan=13 height="10" align="center" valign=middle bgcolor="#BFBFBF"><b><font size=3 color="#FFFFFF">DATOS DEL TRABAJADOR</font></b></td>
            </tr>
          <tr>
            <td style="border-left: 2px solid #000000" height="15" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF" colspan="11"><font color="#000000"><br></font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-left: 2px solid #000000" height="15" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000">Ciudad </font></td>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=4 align="center" valign=middle bgcolor="#FFFFFF"><font color="#000000">{{ausentismo.city}}</font></td>
            <td align="center" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="center" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="right" valign=bottom bgcolor="#FFFFFF"><font color="#000000">Fecha</font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=3 align="center" valign=middle bgcolor="#FFFFFF"><font color="#A6A6A6">{{ausentismo.date}}</font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-left: 2px solid #000000" height="9" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF" colspan="11"><font color="#000000"><br></font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-left: 2px solid #000000" height="15" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000">Nombre</font></td>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=11 align="center" valign=middle bgcolor="#FFFFFF"><font color="#000000">{{ausentismo.name}}</font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-left: 2px solid #000000" height="9" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF" colspan="11"><font color="#000000"><br></font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-left: 2px solid #000000" height="15" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000">Vicepresidencia</font></td>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=11 align="center" valign=middle bgcolor="#FFFFFF"><font color="#000000">{{ausentismo.vice_presidency}}</font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-left: 2px solid #000000" height="9" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF" colspan="11"><font color="#000000"><br></font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-left: 2px solid #000000" height="15" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000">Divisi&oacute;n</font></td>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=11 align="center" valign=middle bgcolor="#FFFFFF"><font color="#000000">{{ausentismo.division}}</font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-left: 2px solid #000000" height="9" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF" colspan="11"><font color="#000000"><br></font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-left: 2px solid #000000" height="15" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000">C&oacute;digo SAP </font></td>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=4 align="center" valign=middle bgcolor="#FFFFFF"><font color="#000000">{{ausentismo.sap}}</font></td>
            <td align="center" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="center" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="right" valign=bottom bgcolor="#FFFFFF"><font color="#000000">Cedula</font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=3 align="center" valign=middle bgcolor="#FFFFFF"><font color="#000000">{{ausentismo.cc}}</font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-bottom: 2px solid #000000; border-left: 2px solid #000000" height="18" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td style="border-bottom: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF" colspan="11"><font color="#000000"><br></font></td>
            <td style="border-bottom: 2px solid #000000; border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td height="18" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF" colspan="11"><font color="#000000"><br></font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          
          
          
          
          <tr>
            <td style="border-top: 2px solid #000000; border-bottom: 2px solid #000000; border-left: 2px solid #000000; border-right: 2px solid #000000" colspan=13 height="15" align="center" valign=middle bgcolor="#BFBFBF"><b><font size=3 color="#FFFFFF">TIPO DE PERMISO Y/O LICENCIA</font></b></td>
            </tr>
          <tr>
            <td style="border-top: 2px solid #000000; border-left: 2px solid #000000" height="12" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td style="border-top: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF" colspan="11"><font color="#000000"><br></font></td>
            <td style="border-top: 2px solid #000000; border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-left: 2px solid #000000" height="15" align="left" valign=bottom bgcolor="#FFFFFF" colspan="3">
              <font color="#000000">Licencia por Luto</font>            
            </td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><input class="mycheck" type="checkbox" disabled></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF" colspan="5">
              <font color="#000000">Licencia Remunerada</font>            
            </td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><input class="mycheck" type="checkbox" checked="true" disabled></td>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=2 rowspan=6 align="left" valign=top bgcolor="#FFFFFF"><font color="#000000">Cual? <br><br>Permiso sindical</font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          
          <tr>
            <td style="border-left: 2px solid #000000" height="15" align="left" valign=bottom bgcolor="#FFFFFF"  colspan="3">
              <font color="#000000">Matrimonio</font>            
            </td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><input class="mycheck" type="checkbox" disabled></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF" colspan="5">
              <font color="#000000">Licencia no remunerada</font>            
            </td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><input class="mycheck" type="checkbox" disabled></td>          
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          
          <tr>
            <td style="border-left: 2px solid #000000" height="15" align="left" valign=bottom bgcolor="#FFFFFF" colspan="3">
              <font color="#000000">Jurado de Votaci&oacute;n</font>           
            </td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><input class="mycheck" type="checkbox" disabled></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF" colspan="5">
              <font color="#000000">Calamidad Domestica</font>            
            </td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><input class="mycheck" type="checkbox" disabled></td>          
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>        
          <tr>
            <td style="border-left: 2px solid #000000" height="15" align="left" valign=bottom bgcolor="#FFFFFF" colspan="3">
              <font color="#000000">Sufragante</font>
            </td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><input class="mycheck" type="checkbox" disabled></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF" colspan="5">
              <font color="#000000">Licencia Maternidad</font>            
            </td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><input class="mycheck" type="checkbox" disabled></td>          
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
        
          <tr>
            <td style="border-left: 2px solid #000000" height="15" align="left" valign=bottom bgcolor="#FFFFFF" colspan="3">
              <font color="#000000">Cita Medica</font>
            </td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><input class="mycheck" type="checkbox" disabled></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF" colspan="5">
              <font color="#000000">Licencia Paternidad</font>            
            </td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><input class="mycheck" type="checkbox" disabled></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          
          <tr>
            <td style="border-left: 2px solid #000000" height="15" align="left" valign=bottom bgcolor="#FFFFFF" colspan="5">
              <font color="#000000">Incapacidad (EG - AT)</font>
            </td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><input class="mycheck" type="checkbox" disabled></td>
            <td align="right" valign=bottom bgcolor="#FFFFFF" colspan="3">
              <font color="#000000">Otro</font>            
            </td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><input class="mycheck" type="checkbox" disabled></td>          
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-bottom: 2px solid #000000; border-left: 2px solid #000000" height="15" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td style="border-bottom: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF" colspan="11"><font color="#000000"><br></font></td>
            <td style="border-bottom: 2px solid #000000; border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>




          <tr>
            <td height="11" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF" colspan="11"><font color="#000000"><br></font></td>
            </tr>
          <tr>
            <td style="border-top: 2px solid #000000; border-bottom: 2px solid #000000; border-left: 2px solid #000000; border-right: 2px solid #000000" colspan=13 height="15" align="center" valign=middle bgcolor="#BFBFBF"><b><font size=3 color="#FFFFFF">INFORMACION DEL PERMISO</font></b></td>
            </tr>
          <tr>
            <td style="border-left: 2px solid #000000" height="9" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF" colspan=""><font color="#000000"><br></font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF" colspan="11"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-left: 2px solid #000000" height="10" align="left" valign=bottom bgcolor="#FFFFFF" colspan="4">
              <font color="#000000">Fecha de inicio:</font>
            </td>          
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=3 align="center" valign=middle bgcolor="#FFFFFF">
              <font color="#000000">{{ausentismo.start_date}}</font>
            </td>
            <td align="left" valign=bottom bgcolor="#FFFFFF" colspan="3">
              <font color="#000000">Hora de Inicio</font>
            </td>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=2 align="center" valign=middle bgcolor="#FFFFFF" sdval="0" sdnum="9226;0;HH:MM">
              <font color="#000000">{{ausentismo.start_hour}}</font>
            </td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-left: 2px solid #000000" height="11" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF" colspan="11"><font color="#000000"><br></font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-left: 2px solid #000000" height="15" align="left" valign=bottom bgcolor="#FFFFFF"  colspan="4">
              <font color="#000000">Fecha de Finalizaci&oacute;n</font>
            </td>          
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=3 align="center" valign=middle bgcolor="#FFFFFF">
              <font color="#000000">{{ausentismo.end_date}}</font>
            </td>
            <td align="left" valign=bottom bgcolor="#FFFFFF" colspan="3">
              <font color="#000000">Hora Finalizaci&oacute;n</font>
            </td>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=2 align="center" valign=middle bgcolor="#FFFFFF" sdval="0" sdnum="9226;0;HH:MM"><font color="#000000">{{ausentismo.end_hour}}</font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-bottom: 2px solid #000000; border-left: 2px solid #000000" height="15" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td style="border-bottom: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF" colspan="8"><font color="#000000"><br></font></td>
            <td style="border-bottom: 2px solid #000000" align="center" valign=bottom bgcolor="#FFFFFF" sdnum="9226;0;HH:MM"><font color="#A6A6A6"><br></font></td>
            <td style="border-bottom: 2px solid #000000" align="center" valign=bottom bgcolor="#FFFFFF" sdnum="9226;0;HH:MM"><font color="#A6A6A6"><br></font></td>
            <td style="border-bottom: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td style="border-bottom: 2px solid #000000; border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td height="15" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF" colspan="12"><font color="#000000"><br></font></td>
            </tr>
          
          
          
          
          
          <tr>
            <td style="border-top: 2px solid #000000; border-bottom: 2px solid #000000; border-left: 2px solid #000000; border-right: 2px solid #000000" colspan=13 rowspan=1 height="40" align="left" valign=top bgcolor="#FFFFFF">
              <b><font color="#000000">Observaciones: {{observaciones}}</font></b>
            </td>
            </tr>
          <tr>
            </tr>
          <tr>
            </tr>
          <tr>
            </tr>
          <tr>
            <td height="15" align="left" valign=top bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=top bgcolor="#FFFFFF" colspan="12"><font color="#000000"><br></font></td>
          </tr>





          <tr>
            <td style="border-top: 2px solid #000000; border-bottom: 2px solid #000000; border-left: 2px solid #000000; border-right: 2px solid #000000" colspan=13 height="15" align="center" valign=middle bgcolor="#BFBFBF">
              <b><font size=3 color="#FFFFFF">ANEXOS</font></b>
            </td>
            </tr>
          <tr>
            <td style="border-left: 2px solid #000000" height="12" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF" colspan="11"><font color="#000000"><br></font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-left: 2px solid #000000" height="15" align="left" valign=top bgcolor="#FFFFFF" colspan="2">
              <font color="#000000">Certificados </font>
              </td>          
            <td align="left" valign=top bgcolor="#FFFFFF">
              <input class="mycheck" type="checkbox" disabled><br>
            </td>          
            <td align="left" valign=top bgcolor="#FFFFFF" colspan="4">
              <font color="#000000">Copia carnet</font></td>
            <td align="left" valign=top bgcolor="#FFFFFF">
              <input class="mycheck" type="checkbox" disabled><br>
            </td>
            <td style="border-right: 1px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=3 rowspan=3 align="left" valign=top bgcolor="#FFFFFF">
              <font color="#000000">Cuales?<br><br>Aprobación permiso sindical</font>
            </td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          
          <tr>
            <td style="border-left: 2px solid #000000" height="15" align="left" valign=top bgcolor="#FFFFFF" colspan="2">
              <font color="#000000">Registros</font>
            </td>          
            <td align="left" valign=top bgcolor="#FFFFFF">
              <input class="mycheck" type="checkbox" disabled><br>
            </td>          
            <td align="left" valign=top bgcolor="#FFFFFF" colspan="4">
              <font color="#000000">Copias Cedulas</font>
            </td>
            <td align="left" valign=top bgcolor="#FFFFFF">
              <input class="mycheck" type="checkbox" disabled>
            </td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          
          <tr>
            <td style="border-left: 2px solid #000000" height="15" align="left" valign=top bgcolor="#FFFFFF" colspan="3">
              <font color="#000000">Historias Clinicas</font>
            </td>          
            <td align="left" valign=top bgcolor="#FFFFFF">
              <input class="mycheck" type="checkbox" disabled><br>
            </td>          
            <td align="right" valign=top bgcolor="#FFFFFF" colspan="3">
              <font color="#000000">Otros</font>
            </td>
            <td align="left" valign=top bgcolor="#FFFFFF">
              <input class="mycheck" type="checkbox" checked="true" disabled>
            </td>
            <td style="border-right: 1px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-bottom: 2px solid #000000; border-left: 2px solid #000000" height="15" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td style="border-bottom: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF" colspan="11"><font color="#000000"><br></font></td>
            <td style="border-bottom: 2px solid #000000; border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          
          
          
          
          
          
          
          
          <tr>
            <td height="17" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF" colspan="12"><font color="#000000"><br></font></td>
            </tr>
          <tr>
            <td style="border-top: 2px solid #000000; border-bottom: 2px solid #000000; border-left: 2px solid #000000; border-right: 2px solid #000000" colspan=13 height="33" align="center" valign=middle bgcolor="#BFBFBF"><b><font size=3 color="#FFFFFF">AUTORIZACIONES</font></b></td>
            </tr>
          <tr>
            <td style="border-left: 2px solid #000000" height="14" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF" colspan="11"><font color="#000000"><br></font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-left: 2px solid #000000" height="36" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000">Nombre Jefe Inmediato<br></font></td>
            <td align="center" valign=bottom bgcolor="#FFFFFF"><font size=1 color="#000000"><br></font></td>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000" align="left" valign=middle bgcolor="#FFFFFF" colspan="5"><font color="#000000">{{ausentismo.boss}}</font></td>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-right: 1px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=3 rowspan=9 align="justify" bgcolor="#FFFFFF"><font size=1 color="#000000">Durante el tiempo de Licencia o permiso no remunerado, &quot;La Empresa&quot; se obliga a continuar realizando las cotizaciones mensuales al Sistema Integral de Seguridad Social en Salud, tanto la parte que le corresponde como empleador, como en la parte que por ley de corresponde pagar a &quot;El Trabajador&quot;. <br>Para lo anterior &quot;El Trabajador&quot; autoriza de manera clara y expresa a &quot;La Empresa&quot; para que se le realicen los descuentos correspondientes  a estos pagos, durante el tiempo que dure esta Licencia o permiso no remunerado, una vez regrese .</font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-left: 2px solid #000000" height="14" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF" colspan="8"><font color="#000000"><br></font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-left: 2px solid #000000" height="30" align="left" valign=middle bgcolor="#FFFFFF"><font color="#000000">Firma Jefe Inmediato</font></td>
            <td align="left" valign=middle bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=6 rowspan=3 align="center" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-left: 2px solid #000000" height="30" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=middle bgcolor="#FFFFFF"><font size=1 color="#000000"><br></font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-left: 2px solid #000000" height="30" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-left: 2px solid #000000" height="17" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF" colspan="8"><font color="#000000"><br></font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-left: 2px solid #000000" height="38" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000">Nombre Director de &Aacute;rea</font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-right: 1px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-left: 2px solid #000000" height="17" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF" colspan="8"><font color="#000000"><br></font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-left: 2px solid #000000" height="30" align="left" valign=middle bgcolor="#FFFFFF"><font color="#000000">Firma Director</font></td>
            <td align="left" valign=middle bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=6 rowspan=3 align="center" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-left: 2px solid #000000" height="14" align="left" valign=middle bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=middle bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-left: 2px solid #000000" height="53" align="left" valign=middle bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=middle bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000" align="left" valign=top bgcolor="#FFFFFF"><font size=1 color="#808080">Firma del Trabajador</font></td>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000" align="left" valign=top bgcolor="#FFFFFF"><font size=1 color="#000000"><br></font></td>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-right: 1px solid #000000" align="left" valign=top bgcolor="#FFFFFF"><font size=1 color="#000000"><br></font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-bottom: 2px solid #000000; border-left: 2px solid #000000" height="18" align="left" valign=middle bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td style="border-bottom: 2px solid #000000" align="left" valign=middle bgcolor="#FFFFFF" colspan="11"><font color="#000000"><br></font></td>
            <td style="border-bottom: 2px solid #000000; border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td height="15" align="left" valign=middle bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=middle bgcolor="#FFFFFF" colspan="11"><font color="#000000"><br></font></td>
            </tr>
          <tr>
            <td style="border-top: 2px solid #000000; border-bottom: 2px solid #000000; border-left: 2px solid #000000; border-right: 2px solid #000000" colspan=13 height="33" align="center" valign=middle bgcolor="#D9D9D9"><b><font size=3 color="#FFFFFF">USO EXCLUSIVO DEL CSRH</font></b></td>
            </tr>
          <tr>
            <td style="border-bottom: 1px solid #000000; border-left: 2px solid #000000; border-right: 1px solid #000000" colspan=3 height="81" align="left" valign=middle bgcolor="#FFFFFF"><font color="#000000">Nombre y fecha de recibido</font></td>
            <td style="border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 2px solid #000000" colspan=10 align="center" valign=middle bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            </tr>
          <tr>
            <td style="border-left: 2px solid #000000" colspan=3 rowspan=3 height="56" align="left" valign=middle bgcolor="#FFFFFF"><font color="#000000">Validaci&oacute;n de la Informaci&oacute;n:</font></td>
            <td align="left" valign=middle bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="center" valign=middle bgcolor="#FFFFFF"><font color="#BFBFBF"><br></font></td>
            <td align="center" valign=middle bgcolor="#FFFFFF"><font color="#BFBFBF"><br></font></td>
            <td align="center" valign=middle bgcolor="#FFFFFF"><font color="#BFBFBF"><br></font></td>
            <td align="center" valign=middle bgcolor="#FFFFFF"><font color="#BFBFBF"><br></font></td>
            <td colspan=4 align="center" valign=middle bgcolor="#FFFFFF"><font color="#BFBFBF"><br></font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td align="left" valign=middle bgcolor="#FFFFFF"><font color="#000000"><input class="mycheck" type="checkbox"><br></font></td>
            <td align="left" valign=middle bgcolor="#FFFFFF"><font color="#000000">  Ok</font></td>
            <td align="left" valign=middle bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="left" valign=middle bgcolor="#FFFFFF"><input class="mycheck" type="checkbox"><br></td>
            <td align="left" valign=middle bgcolor="#FFFFFF"><font color="#000000">  Incompleto</font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td align="center" valign=middle bgcolor="#FFFFFF"><font color="#BFBFBF"><input class="mycheck" type="checkbox"><br></font></td>
            <td align="left" valign=middle bgcolor="#FFFFFF"><font color="#000000">  Devuelto</font></td>
            <td align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td align="left" valign=middle bgcolor="#FFFFFF" colspan="9"><font color="#000000"><br></font></td>
            <td style="border-right: 2px solid #000000" align="left" valign=bottom bgcolor="#FFFFFF"><font color="#000000"><br></font></td>
          </tr>
          <tr>
            <td style="border-top: 1px solid #000000; border-bottom: 2px solid #000000; border-left: 2px solid #000000; border-right: 2px solid #000000" colspan=13 rowspan=2 height="87" align="left" valign=top bgcolor="#FFFFFF"><font color="#000000">Observaciones:</font></td>
            </tr>
        </table>


      </div>
    </div>
  </div>
  <!-- #page-request -->
</template>

<script>
//import { mapActions, mapState } from "vuex";
import serverConfig from "./../../services/config";

export default {
  props: {
    ausentismo: {
      type: Object
    },
    observaciones: {
      type: String
    },
    sharp_id: {
      type: String
    },
    id: {
      type: String
    },
  },
  name: "FormatAbsentismo",
  components: {  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      error: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      success: {
        flag: false,
        class: "", //is-valid
        message: "",
      },      
      template: {
        data: "",
      },
      monthNames: ["cero", "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
      "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
      colaboradores: [],
      tiquetes: '',
      ciudadActividad: '',
    };
  },
  beforeMount() {     
    
  
  }, 
  computed: {
    
  },
  methods: {
   
  
    uniq(a) {
      var seen = {};
      var out = [];
      var len = a.length;
      var j = 0;
      for(var i = 0; i < len; i++) {
          var item = a[i];
          if(seen[item] !== 1) {
                seen[item] = 1;
                out[j++] = item;
          }
      }
      return out;
    }
  },
};
</script>

<style lang="scss">
.page-format-absentismo {
  .page-content-absentismo {    
    body,div,table,thead,tbody,tfoot,tr,th,td,p{ 
      font-family:"Calibri"; font-size:x-small 
    }
    a.comment-indicator:hover + comment { 
      background:#ffd; position:absolute; display:block; border:1px solid black; padding:0.5em;  
    } 
    a.comment-indicator { 
      background:red; display:inline-block; border:1px solid black; width:0.5em; height:0.5em;  
    } 
    comment { 
      display:none;  
    } 
  }
}
</style>